/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AplicarCargoModelo } from '../model/aplicarCargoModelo';
import { AvaliacaoCargo } from '../model/avaliacaoCargo';
import { Cargo } from '../model/cargo';
import { NewAvaliadoReferenciado } from '../model/newAvaliadoReferenciado';
import { NewFiltroAderencia } from '../model/newFiltroAderencia';
import { NewFiltroAderenciaCargos } from '../model/newFiltroAderenciaCargos';
import { MicrosoftAspNetCoreMvcFileContentResult } from '../model/microsoftAspNetCoreMvcFileContentResult';
import { NewPerfil } from '../model/newPerfil';
import { NewUpdCargo } from '../model/newUpdCargo';
import { NewWebhook } from '../model/newWebhook';
import { PessoaAderente } from '../model/pessoaAderente';
import { TipoCargo } from '../model/tipoCargo';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';


@Injectable()
export class CargoApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Listar Aderência dos Avaliados ao Cargo
     * 
     * @param cargoId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdAderenciaAvaliadosPut(cargoId: number, body?: NewFiltroAderencia, observe?: 'body', reportProgress?: boolean): Observable<Array<PessoaAderente>>;
    public v1CargoCargoIdAderenciaAvaliadosPut(cargoId: number, body?: NewFiltroAderencia, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PessoaAderente>>>;
    public v1CargoCargoIdAderenciaAvaliadosPut(cargoId: number, body?: NewFiltroAderencia, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PessoaAderente>>>;
    public v1CargoCargoIdAderenciaAvaliadosPut(cargoId: number, body?: NewFiltroAderencia, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdAderenciaAvaliadosPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<PessoaAderente>>('put',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/aderencia_avaliados`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aplicar Cargo Modelo com Base no Código de Referência
     * 
     * @param cargoId 
     * @param codigoReferencia 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdAplicarModeloCodigoReferenciaPost(cargoId: number, codigoReferencia: string, body?: AplicarCargoModelo, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoCargoIdAplicarModeloCodigoReferenciaPost(cargoId: number, codigoReferencia: string, body?: AplicarCargoModelo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoCargoIdAplicarModeloCodigoReferenciaPost(cargoId: number, codigoReferencia: string, body?: AplicarCargoModelo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoCargoIdAplicarModeloCodigoReferenciaPost(cargoId: number, codigoReferencia: string, body?: AplicarCargoModelo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdAplicarModeloCodigoReferenciaPost.');
        }

        if (codigoReferencia === null || codigoReferencia === undefined) {
            throw new Error('Required parameter codigoReferencia was null or undefined when calling v1CargoCargoIdAplicarModeloCodigoReferenciaPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Cargo>('post',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/aplicar_modelo/${encodeURIComponent(String(codigoReferencia))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Desassociar Avaliação do Cargo
     * 
     * @param cargoId 
     * @param avaliacaoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdAvaliacoesAvaliacaoIdDelete(cargoId: number, avaliacaoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1CargoCargoIdAvaliacoesAvaliacaoIdDelete(cargoId: number, avaliacaoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1CargoCargoIdAvaliacoesAvaliacaoIdDelete(cargoId: number, avaliacaoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1CargoCargoIdAvaliacoesAvaliacaoIdDelete(cargoId: number, avaliacaoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdAvaliacoesAvaliacaoIdDelete.');
        }

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1CargoCargoIdAvaliacoesAvaliacaoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/avaliacoes/${encodeURIComponent(String(avaliacaoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Associar Avaliação ao Cargo
     * 
     * @param cargoId 
     * @param avaliacaoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdAvaliacoesAvaliacaoIdPost(cargoId: number, avaliacaoId: number, observe?: 'body', reportProgress?: boolean): Observable<AvaliacaoCargo>;
    public v1CargoCargoIdAvaliacoesAvaliacaoIdPost(cargoId: number, avaliacaoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AvaliacaoCargo>>;
    public v1CargoCargoIdAvaliacoesAvaliacaoIdPost(cargoId: number, avaliacaoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AvaliacaoCargo>>;
    public v1CargoCargoIdAvaliacoesAvaliacaoIdPost(cargoId: number, avaliacaoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdAvaliacoesAvaliacaoIdPost.');
        }

        if (avaliacaoId === null || avaliacaoId === undefined) {
            throw new Error('Required parameter avaliacaoId was null or undefined when calling v1CargoCargoIdAvaliacoesAvaliacaoIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AvaliacaoCargo>('post',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/avaliacoes/${encodeURIComponent(String(avaliacaoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Avaliações Associadas ao Cargo
     * 
     * @param cargoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdAvaliacoesGet(cargoId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AvaliacaoCargo>>;
    public v1CargoCargoIdAvaliacoesGet(cargoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AvaliacaoCargo>>>;
    public v1CargoCargoIdAvaliacoesGet(cargoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AvaliacaoCargo>>>;
    public v1CargoCargoIdAvaliacoesGet(cargoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdAvaliacoesGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AvaliacaoCargo>>('get',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/avaliacoes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Excluir Avaliado Referenciado do Cargo
     * 
     * @param cargoId 
     * @param codigoReferencia 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdAvaliadosReferenciadosCodigoReferenciaDelete(cargoId: number, codigoReferencia: string, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoCargoIdAvaliadosReferenciadosCodigoReferenciaDelete(cargoId: number, codigoReferencia: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoCargoIdAvaliadosReferenciadosCodigoReferenciaDelete(cargoId: number, codigoReferencia: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoCargoIdAvaliadosReferenciadosCodigoReferenciaDelete(cargoId: number, codigoReferencia: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdAvaliadosReferenciadosCodigoReferenciaDelete.');
        }

        if (codigoReferencia === null || codigoReferencia === undefined) {
            throw new Error('Required parameter codigoReferencia was null or undefined when calling v1CargoCargoIdAvaliadosReferenciadosCodigoReferenciaDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Cargo>('delete',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/avaliados_referenciados/${encodeURIComponent(String(codigoReferencia))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Avaliado Referenciado no Cargo
     * 
     * @param body 
     * @param cargoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdAvaliadosReferenciadosPost(body: NewAvaliadoReferenciado, cargoId: number, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoCargoIdAvaliadosReferenciadosPost(body: NewAvaliadoReferenciado, cargoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoCargoIdAvaliadosReferenciadosPost(body: NewAvaliadoReferenciado, cargoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoCargoIdAvaliadosReferenciadosPost(body: NewAvaliadoReferenciado, cargoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling v1CargoCargoIdAvaliadosReferenciadosPost.');
        }

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdAvaliadosReferenciadosPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Cargo>('post',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/avaliados_referenciados`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Perfis Configurados para o Cargo
     * 
     * @param cargoId 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdCienciaCienciaIdPerfisGet(cargoId: number, cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewPerfil>>;
    public v1CargoCargoIdCienciaCienciaIdPerfisGet(cargoId: number, cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewPerfil>>>;
    public v1CargoCargoIdCienciaCienciaIdPerfisGet(cargoId: number, cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewPerfil>>>;
    public v1CargoCargoIdCienciaCienciaIdPerfisGet(cargoId: number, cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdCienciaCienciaIdPerfisGet.');
        }

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CargoCargoIdCienciaCienciaIdPerfisGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<NewPerfil>>('get',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/ciencia/${encodeURIComponent(String(cienciaId))}/perfis`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Configuração de Perfis para o Cargo
     * 
     * @param body 
     * @param cargoId 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdCienciaCienciaIdPerfisPut(body: Array<NewPerfil>, cargoId: number, cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewPerfil>>;
    public v1CargoCargoIdCienciaCienciaIdPerfisPut(body: Array<NewPerfil>, cargoId: number, cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewPerfil>>>;
    public v1CargoCargoIdCienciaCienciaIdPerfisPut(body: Array<NewPerfil>, cargoId: number, cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewPerfil>>>;
    public v1CargoCargoIdCienciaCienciaIdPerfisPut(body: Array<NewPerfil>, cargoId: number, cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling v1CargoCargoIdCienciaCienciaIdPerfisPut.');
        }

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdCienciaCienciaIdPerfisPut.');
        }

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CargoCargoIdCienciaCienciaIdPerfisPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<NewPerfil>>('put',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/ciencia/${encodeURIComponent(String(cienciaId))}/perfis`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Excluir Cargo
     * 
     * @param cargoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdDelete(cargoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1CargoCargoIdDelete(cargoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1CargoCargoIdDelete(cargoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1CargoCargoIdDelete(cargoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Novo Cargo com Base em Cargo Existente
     * 
     * @param cargoId 
     * @param novoTitulo 
     * @param novaDescricao 
     * @param novaArea 
     * @param novoNivel 
     * @param novoTipoCargo 
     * @param novoCodigoReferencia 
     * @param incluirAvaliacoesAssociadas 
     * @param incluirPerfisAssociados 
     * @param incluirWebhooks 
     * @param pessoaJuridicaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdDuplicarPost(cargoId: number, novoTitulo?: string, novaDescricao?: string, novaArea?: string, novoNivel?: string, novoTipoCargo?: TipoCargo, novoCodigoReferencia?: string, incluirAvaliacoesAssociadas?: boolean, incluirPerfisAssociados?: boolean, incluirWebhooks?: boolean, pessoaJuridicaId?: number, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoCargoIdDuplicarPost(cargoId: number, novoTitulo?: string, novaDescricao?: string, novaArea?: string, novoNivel?: string, novoTipoCargo?: TipoCargo, novoCodigoReferencia?: string, incluirAvaliacoesAssociadas?: boolean, incluirPerfisAssociados?: boolean, incluirWebhooks?: boolean, pessoaJuridicaId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoCargoIdDuplicarPost(cargoId: number, novoTitulo?: string, novaDescricao?: string, novaArea?: string, novoNivel?: string, novoTipoCargo?: TipoCargo, novoCodigoReferencia?: string, incluirAvaliacoesAssociadas?: boolean, incluirPerfisAssociados?: boolean, incluirWebhooks?: boolean, pessoaJuridicaId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoCargoIdDuplicarPost(cargoId: number, novoTitulo?: string, novaDescricao?: string, novaArea?: string, novoNivel?: string, novoTipoCargo?: TipoCargo, novoCodigoReferencia?: string, incluirAvaliacoesAssociadas?: boolean, incluirPerfisAssociados?: boolean, incluirWebhooks?: boolean, pessoaJuridicaId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdDuplicarPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (novoTitulo !== undefined && novoTitulo !== null) {
            queryParameters = queryParameters.set('novoTitulo', <any>novoTitulo);
        }
        if (novaDescricao !== undefined && novaDescricao !== null) {
            queryParameters = queryParameters.set('novaDescricao', <any>novaDescricao);
        }
        if (novaArea !== undefined && novaArea !== null) {
            queryParameters = queryParameters.set('novaArea', <any>novaArea);
        }
        if (novoNivel !== undefined && novoNivel !== null) {
            queryParameters = queryParameters.set('novoNivel', <any>novoNivel);
        }
        if (novoTipoCargo !== undefined && novoTipoCargo !== null) {
            queryParameters = queryParameters.set('novoTipoCargo', <any>novoTipoCargo);
        }
        if (novoCodigoReferencia !== undefined && novoCodigoReferencia !== null) {
            queryParameters = queryParameters.set('novoCodigoReferencia', <any>novoCodigoReferencia);
        }
        if (incluirAvaliacoesAssociadas !== undefined && incluirAvaliacoesAssociadas !== null) {
            queryParameters = queryParameters.set('incluirAvaliacoesAssociadas', <any>incluirAvaliacoesAssociadas);
        }
        if (incluirPerfisAssociados !== undefined && incluirPerfisAssociados !== null) {
            queryParameters = queryParameters.set('incluirPerfisAssociados', <any>incluirPerfisAssociados);
        }
        if (incluirWebhooks !== undefined && incluirWebhooks !== null) {
            queryParameters = queryParameters.set('incluirWebhooks', <any>incluirWebhooks);
        }
        if (pessoaJuridicaId !== undefined && pessoaJuridicaId !== null) {
            queryParameters = queryParameters.set('pessoaJuridicaId', <any>pessoaJuridicaId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Cargo>('post',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/duplicar`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Cargo pelo Id
     * 
     * @param cargoId 
     * @param incluirExcluidos 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdGet(cargoId: number, incluirExcluidos?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoCargoIdGet(cargoId: number, incluirExcluidos?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoCargoIdGet(cargoId: number, incluirExcluidos?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoCargoIdGet(cargoId: number, incluirExcluidos?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (incluirExcluidos !== undefined && incluirExcluidos !== null) {
            queryParameters = queryParameters.set('incluirExcluidos', <any>incluirExcluidos);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Cargo>('get',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Cargo
     * 
     * @param cargoId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdPut(cargoId: number, body?: NewUpdCargo, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoCargoIdPut(cargoId: number, body?: NewUpdCargo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoCargoIdPut(cargoId: number, body?: NewUpdCargo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoCargoIdPut(cargoId: number, body?: NewUpdCargo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Cargo>('put',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restaurar Cargo Excluído
     * 
     * @param cargoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdRestaurarPut(cargoId: number, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoCargoIdRestaurarPut(cargoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoCargoIdRestaurarPut(cargoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoCargoIdRestaurarPut(cargoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdRestaurarPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Cargo>('put',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/restaurar`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Configurar Webhook para o Cargo
     * 
     * @param cargoId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdWebhookPost(cargoId: number, body?: NewWebhook, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoCargoIdWebhookPost(cargoId: number, body?: NewWebhook, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoCargoIdWebhookPost(cargoId: number, body?: NewWebhook, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoCargoIdWebhookPost(cargoId: number, body?: NewWebhook, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdWebhookPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Cargo>('post',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/webhook`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Excluir Webhook do Cargo
     * 
     * @param cargoId 
     * @param webhookId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoCargoIdWebhookWebhookIdDelete(cargoId: number, webhookId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1CargoCargoIdWebhookWebhookIdDelete(cargoId: number, webhookId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1CargoCargoIdWebhookWebhookIdDelete(cargoId: number, webhookId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1CargoCargoIdWebhookWebhookIdDelete(cargoId: number, webhookId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1CargoCargoIdWebhookWebhookIdDelete.');
        }

        if (webhookId === null || webhookId === undefined) {
            throw new Error('Required parameter webhookId was null or undefined when calling v1CargoCargoIdWebhookWebhookIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/cargo/${encodeURIComponent(String(cargoId))}/webhook/${encodeURIComponent(String(webhookId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Cargos do Cliente
     * 
     * @param pessoaJuridicaId 
     * @param withoutChildren 
     * @param incluirExcluidos 
     * @param tipoCargo 
     * @param codigoReferencia 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoClientePessoaJuridicaIdGet(pessoaJuridicaId: number, withoutChildren?: boolean, incluirExcluidos?: boolean, tipoCargo?: TipoCargo, codigoReferencia?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Cargo>>;
    public v1CargoClientePessoaJuridicaIdGet(pessoaJuridicaId: number, withoutChildren?: boolean, incluirExcluidos?: boolean, tipoCargo?: TipoCargo, codigoReferencia?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Cargo>>>;
    public v1CargoClientePessoaJuridicaIdGet(pessoaJuridicaId: number, withoutChildren?: boolean, incluirExcluidos?: boolean, tipoCargo?: TipoCargo, codigoReferencia?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Cargo>>>;
    public v1CargoClientePessoaJuridicaIdGet(pessoaJuridicaId: number, withoutChildren?: boolean, incluirExcluidos?: boolean, tipoCargo?: TipoCargo, codigoReferencia?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pessoaJuridicaId === null || pessoaJuridicaId === undefined) {
            throw new Error('Required parameter pessoaJuridicaId was null or undefined when calling v1CargoClientePessoaJuridicaIdGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }
        if (incluirExcluidos !== undefined && incluirExcluidos !== null) {
            queryParameters = queryParameters.set('incluirExcluidos', <any>incluirExcluidos);
        }
        if (tipoCargo !== undefined && tipoCargo !== null) {
            queryParameters = queryParameters.set('tipoCargo', <any>tipoCargo);
        }
        if (codigoReferencia !== undefined && codigoReferencia !== null) {
            queryParameters = queryParameters.set('codigoReferencia', <any>codigoReferencia);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Cargo>>('get',`${this.basePath}/v1/cargo/cliente/${encodeURIComponent(String(pessoaJuridicaId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Cargos
     * 
     * @param withoutChildren 
     * @param incluirExcluidos 
     * @param tipoCargo 
     * @param codigoReferencia 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoGet(withoutChildren?: boolean, incluirExcluidos?: boolean, tipoCargo?: TipoCargo, codigoReferencia?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Cargo>>;
    public v1CargoGet(withoutChildren?: boolean, incluirExcluidos?: boolean, tipoCargo?: TipoCargo, codigoReferencia?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Cargo>>>;
    public v1CargoGet(withoutChildren?: boolean, incluirExcluidos?: boolean, tipoCargo?: TipoCargo, codigoReferencia?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Cargo>>>;
    public v1CargoGet(withoutChildren?: boolean, incluirExcluidos?: boolean, tipoCargo?: TipoCargo, codigoReferencia?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }
        if (incluirExcluidos !== undefined && incluirExcluidos !== null) {
            queryParameters = queryParameters.set('incluirExcluidos', <any>incluirExcluidos);
        }
        if (tipoCargo !== undefined && tipoCargo !== null) {
            queryParameters = queryParameters.set('tipoCargo', <any>tipoCargo);
        }
        if (codigoReferencia !== undefined && codigoReferencia !== null) {
            queryParameters = queryParameters.set('codigoReferencia', <any>codigoReferencia);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Cargo>>('get',`${this.basePath}/v1/cargo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Planilha Excel dos Cargos Informados
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoObterplanilhaPut(body?: NewFiltroAderenciaCargos, observe?: 'body', reportProgress?: boolean): Observable<MicrosoftAspNetCoreMvcFileContentResult>;
    public v1CargoObterplanilhaPut(body?: NewFiltroAderenciaCargos, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MicrosoftAspNetCoreMvcFileContentResult>>;
    public v1CargoObterplanilhaPut(body?: NewFiltroAderenciaCargos, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MicrosoftAspNetCoreMvcFileContentResult>>;
    public v1CargoObterplanilhaPut(body?: NewFiltroAderenciaCargos, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request('put',`${this.basePath}/v1/cargo/obterplanilha`,
            {
                body: body,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Novo Cargo
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CargoPost(body?: NewUpdCargo, observe?: 'body', reportProgress?: boolean): Observable<Cargo>;
    public v1CargoPost(body?: NewUpdCargo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Cargo>>;
    public v1CargoPost(body?: NewUpdCargo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Cargo>>;
    public v1CargoPost(body?: NewUpdCargo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Cargo>('post',`${this.basePath}/v1/cargo`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
